import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';

const IncompatibleStockItemsModal = ({
  incompatibleStockItems,
  onCloseClicked,
}) => {
  return (
    <SimpleModal show={true} size="md">
      <ModalHeader title="Incompatible Stock Items" />
      <ModalBody>
        <p>
          Unfortunately, the current machine and/or lugging selection is not
          compatible with some stock items in this quote.
        </p>
        <p className="mb-1">
          The following stock items have been converted to Build to Order:
        </p>
        <ul>
          {incompatibleStockItems.map((x, idx) => (
            <li key={idx}>
              {x.name} - {x.partNumber}
            </li>
          ))}
        </ul>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-secondary" onClick={onCloseClicked}>
          Close
        </button>
      </ModalFooter>
    </SimpleModal>
  );
};

IncompatibleStockItemsModal.propTypes = {
  incompatibleStockItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      partNumber: PropTypes.string.isRequired,
    })
  ),
};

export default IncompatibleStockItemsModal;
